import { render, staticRenderFns } from "./cdKey.vue?vue&type=template&id=68c19a92&scoped=true"
import script from "./cdKey.vue?vue&type=script&lang=js"
export * from "./cdKey.vue?vue&type=script&lang=js"
import style0 from "./cdKey.vue?vue&type=style&index=0&id=68c19a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c19a92",
  null
  
)

export default component.exports